/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAllAgentOptimizationResultsPathParams = NonNullable<
  operations['listAllAgentOptimizationResults']['parameters']['path']
>;

export type ListAllAgentOptimizationResultsQueryParams = NonNullable<
  operations['listAllAgentOptimizationResults']['parameters']['query']
>;

export interface Input extends ListAllAgentOptimizationResultsPathParams {
  apiVersion?: string;
  query?: ListAllAgentOptimizationResultsQueryParams;
}

export async function listAllAgentOptimizationResults(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/agent-optimizations/{optimizationKey}/all-results', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
